import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";
import CompanyView from "./CompanyView";
import PaymentView from "./PaymentView";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    // "scroll", not "auto" — the row count here changes with every filter
    // tweak (both tabs), and "auto" toggles the scrollbar gutter in and out
    // as content height crosses the viewport threshold, shifting the whole
    // page horizontally. AdminInvoices (frontend/src/pages/Financeiro/index.js)
    // already uses "scroll" for the same reason.
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  tabs: {
    marginBottom: theme.spacing(2),
  },
}));

const SuperFinanceiro = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [tab, setTab] = useState("empresa");

  if (!user?.super) {
    return <ForbiddenPage />;
  }

  return (
    <MainContainer>
      <MainHeader>
        <Title>Financeiro — Visão Geral</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <Tabs
          className={classes.tabs}
          value={tab}
          onChange={(_event, newValue) => setTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Visão por Empresa" value="empresa" />
          <Tab label="Visão por Pagamento" value="pagamento" />
        </Tabs>

        {tab === "empresa" ? <CompanyView /> : <PaymentView />}
      </Paper>
    </MainContainer>
  );
};

export default SuperFinanceiro;
